<template>
  <wui-btn
    data-test="create-button"
    :disabled="disabled!"
    variant="positive"
    state="alpha"
    icon
    prepend-icon="saveFloppyM"
    auto-loading
    @click="onSave"
  />
</template>
<script setup lang="ts">
import { useRenderNotifier, WuiBtn } from '@wui/common-library'

import { BlackWhiteListEntity, useBlackWhiteListStore } from '@/entities/black-white-list'

import { useLocalization } from '@/shared/composables/localization'

const { saveDraft } = useBlackWhiteListStore()
const { update } = useBlackWhiteListStore()
const { notifyError, notifySuccess } = useRenderNotifier()
const { t } = useLocalization()

const props = defineProps<{
  disabled?: boolean
  isNew?: boolean
  item?: BlackWhiteListEntity
}>()

const emit = defineEmits<{
  (event: 'saved'): void
}>()

const onSave = async () => {
  if (props.isNew) {
    try {
      await saveDraft()
      emit('saved')
      notifySuccess(t('common.successSave'))
    } catch {
      notifyError(t('common.failedToSaveNewElementList'))
    }
  }
  else {
    if (props.item) {
      saveBlackWhiteListRow(props.item)
    }
  }
}

const saveBlackWhiteListRow = async (payload: BlackWhiteListEntity) => {
  try {
    await update(payload as BlackWhiteListEntity)
    notifySuccess(t('common.successUpdate'))
  } catch {
    notifyError(t('common.failedToChangeElement'))
  }
}
</script>
